/**
 * Columnas de la grilla "Seguimiento de secuencias" (VEC-3474), para `GridColumnSelector` y `useColumnVisibility` (src/commons/grid/).
 *
 * El orden es el del `thead`, y cada `messageId` es el del encabezado de la columna: el selector tiene que decir lo mismo que la tabla.
 * `fixed: true` saca la columna del selector y la deja siempre visible: el vehículo identifica la fila (y lleva la franja del estado cuando está
 * abierta) y la última es la flecha que abre el detalle.
 */

export const SEGUIMIENTO_INGRESOS_COLUMNAS_STORAGE_KEY = 'SeguimientoIngresosGrid_columnas';

export const buildSeguimientoIngresosColumns = () => [
	{ name: 'movil', fixed: true },
	{ name: 'secuencia', messageId: 'formularioSecuenciaIntentoGrid.column_SECUENCIA.label', label: 'Secuencia' },
	{ name: 'estado', messageId: 'formularioSecuenciaIntentoGrid.column_ESTADO.label', label: 'Estado' },
	{ name: 'avance', messageId: 'formularioSecuenciaIntentoGrid.column_AVANCE.label', label: 'Avance' },
	{ name: 'intento', messageId: 'formularioSecuenciaIntentoGrid.column_INTENTO.label', label: 'Intento' },
	{ name: 'fechaInicio', messageId: 'formularioSecuenciaIntentoGrid.column_FECHA_INICIO.label', label: 'Fecha inicio' },
	{ name: 'fechaFin', messageId: 'formularioSecuenciaIntentoGrid.column_FECHA_FIN.label', label: 'Fecha fin' },
	{ name: 'detalle', fixed: true },
];
